import React from 'react';

function PublicFramePage() {
  return (
    <iframe
      src="https://rbp-dev.qala-ai.com/public"
      style={{ height: '100%' }}
    />
  );
}

export default PublicFramePage;
